import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import { BCol, BFormGroup, BFormInput, BRow } from "@/lib/typed-bootstrap";

import { IEnumValueState } from "@/models";
import { removeSpecialCharacters } from "@/utils";

import styles from "./FormEnumValue.component.module.scss";

@Component
export default class FormEnumValue extends Vue {
  _tsx!: tsx.DeclareProps<{
    value: FormEnumValue["value"];
    isUnique?: FormEnumValue["isUnique"];
  }> &
    tsx.DeclareOnEvents<{
      onInput: IEnumValueState;
      onDelete: void;
    }>;

  $refs!: {
    enumValueInput: HTMLFormElement;
  };

  @Prop({ required: true }) value!: IEnumValueState;
  @Prop({ default: null }) readonly isUnique!: boolean | null;

  @Emit("delete") onDelete() {}
  @Emit("input") onInput(_event: IEnumValueState) {}

  mounted() {
    if (!this.value.name) {
      this.$refs.enumValueInput?.focus();
    }
  }

  inputFieldFormatter(value: string): string {
    return removeSpecialCharacters(value).replace(/(^\d)/g, "");
  }

  update(key: keyof IEnumValueState, value: string): void {
    this.$emit("input", { ...this.value, [key]: value });
  }

  render() {
    return (
      <BFormGroup class={styles.formGroup} state={this.isUnique}>
        <BRow alignV="center" class={styles.row}>
          <BCol class={styles.col}>
            <button
              type="button"
              class={styles.delete}
              onClick={(e) => {
                e.preventDefault();
                this.onDelete();
              }}
            />
            <BFormInput
              type="text"
              class="default__form-input"
              ref="enumValueInput"
              placeholder="Enter enum value"
              value={this.value.name}
              onInput={(newVal) => this.update("name", newVal as string)}
              maxLength={64}
              required
              state={this.isUnique}
              formatter={this.inputFieldFormatter}
              trim
            />
          </BCol>
        </BRow>
      </BFormGroup>
    );
  }
}
